// extracted by mini-css-extract-plugin
module.exports =  {"input-param":"input-param--JBHEv","inputParam":"input-param--JBHEv"};